<form autocomplete="off" (ngSubmit)="save(studyForm)" id="studyForm" #studyForm="ngForm">
  <div class="modal-wrapper">
    <div class="overlay" *ngIf="showLoader">
      <app-spinner></app-spinner>
    </div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" *ngIf="!leveragedStudyId; else leveragedStudy">New Study</h4>
      <ng-template #leveragedStudy>
        <h4 class="modal-title" id="modal-basic-title">Leverage Existing Study</h4>
      </ng-template>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body ey-new-study-body">
      <div class="row">
        <div class="col-12">
          <ng-container *ngIf="!formCompleted">
            <div class="row" *ngIf="showErrorMessage">
              <div class="col-lg-12">
                <div class="bg-danger text-white pb-2 pt-2 ps-2 pe-2">
                  <i class="material-icons ey-material-icon">error</i> {{ errorMessage }}
                  below.
                </div>
              </div>
            </div>
            <div class="ey-wizard-steps" [ngClass]="{ 'leverage-study': !!leveragedStudyId }">
              <ul ngbNav #nav="ngbNav" [(activeId)]="selectedTab" (navChange)="selectedTab = $event.nextId">
                <li [ngbNavItem]="0" *ngIf="leveragedStudyId" [disabled]="developmentMode">
                  <a ngbNavLink id="leverageStudy">
                    <span
                      class="p-steps-number joinline"
                      *ngIf="!studyInfoValid || (studyInfoValid && selectedTab === tabsteps.leverageStudy)"
                    ></span>
                    <i class="material-icons joinline" *ngIf="studyInfoValid && !(selectedTab === tabsteps.leverageStudy)"> check_circle </i>
                    <span class="p-steps-title" [ngClass]="{ completedTab: studyInfoValid && !(selectedTab === tabsteps.leverageStudy) }">
                      Leverage Study
                    </span>
                  </a>
                  <ng-template ngbNavContent>
                    <div class="leverage-study-stage">
                      <div class="lbl-choose-leverage-option">Choose option:</div>
                      <div class="row">
                        <div class="col-12">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input
                              type="radio"
                              id="copyStudy"
                              name="copyStudy"
                              class="custom-control-input"
                              [value]="studySetup"
                              [(ngModel)]="selectedLeverageType"
                              required
                            />
                            <label class="custom-control-label form-check-label" for="copyStudy"> Copy Study Setup only </label>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input
                              type="radio"
                              id="copyStudyWithSS"
                              name="copyStudyWithSS"
                              class="custom-control-input"
                              [value]="studySetupWithSearchStrategy"
                              [(ngModel)]="selectedLeverageType"
                            />
                            <label class="custom-control-label form-check-label" for="copyStudyWithSS">
                              Copy Study Setup with other Study settings and retain the Search results
                            </label>
                          </div>
                        </div>
                        <div class="col-12" *ngIf="hasReclassItems">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input
                              type="radio"
                              id="copyStudyWithSSAndReclass"
                              name="copyStudyWithSSAndReclass"
                              class="custom-control-input"
                              [value]="studySetupWithSearchStrategyAndRestatements"
                              [(ngModel)]="selectedLeverageType"
                            />
                            <label class="custom-control-label form-check-label" for="copyStudyWithSSAndReclass">
                              Copy Study Setup with other Study settings and retain the Search results with restatements
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-2" *ngIf="!studySetupOnlySelected">
                      <div class="info-item icon-ai-ml-info">
                        <i class="material-icons">error</i>
                      </div>
                      <div class="info-item info-text">
                        If the selected data feed release will be refreshed for the study, please review the comparability decision and results to
                        ensure that they are still applicable
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="1" [disabled]="developmentMode">
                  <a ngbNavLink id="studyInfo">
                    <span
                      class="p-steps-number joinline"
                      *ngIf="!studyInfoValid || (studyInfoValid && selectedTab === tabsteps.leverageStudy)"
                    ></span>
                    <i class="material-icons joinline" *ngIf="studyInfoValid && !(selectedTab === tabsteps.leverageStudy)"> check_circle </i>
                    <span class="p-steps-title" [ngClass]="{ completedTab: studyInfoValid && !(selectedTab === tabsteps.leverageStudy) }">
                      Study Information
                    </span>
                  </a>
                  <ng-template ngbNavContent>
                    <app-studyinfo
                      [studyVM]="newStudy"
                      [submitted]="submitClicked"
                      [leveragedStudy]="!!leveragedStudyId && saveComparables"
                      [isAIEnableDisableToggleOnYes]="isAIEnableDisableToggleOnYes"
                    ></app-studyinfo>
                  </ng-template>
                </li>

                <li [ngbNavItem]="2" [disabled]="developmentMode">
                  <a ngbNavLink id="testedPartyInfo">
                    <span
                      class="p-steps-number joinline"
                      *ngIf="!testedPartyInfoValid || (testedPartyInfoValid && selectedTab === tabsteps.studyInfo)"
                    ></span>
                    <i class="material-icons joinline" *ngIf="testedPartyInfoValid && !(selectedTab === tabsteps.studyInfo)"> check_circle </i>
                    <span class="p-steps-title" [ngClass]="{ completedTab: testedPartyInfoValid && !(selectedTab === tabsteps.studyInfo) }">
                      Tested Party Information
                    </span>
                  </a>
                  <ng-template ngbNavContent>
                    <app-testedpartyinfo
                      [studyVM]="newStudy"
                      [submitted]="submitClicked"
                      [isNewStudyIndustryBlank]="isNewStudyIndustryBlank"
                    ></app-testedpartyinfo>
                  </ng-template>
                </li>

                <li [ngbNavItem]="3" [disabled]="developmentMode">
                  <a ngbNavLink id="studyAccess">
                    <span
                      class="p-steps-number joinline"
                      *ngIf="!studyAccessInfoValid || (studyAccessInfoValid && selectedTab === tabsteps.testedPartyInfo)"
                    ></span>
                    <i class="material-icons joinline" *ngIf="studyAccessInfoValid && !(selectedTab === tabsteps.testedPartyInfo)"> check_circle </i>
                    <span class="p-steps-title" [ngClass]="{ completedTab: studyAccessInfoValid && !(selectedTab === tabsteps.testedPartyInfo) }">
                      Study Access
                    </span>
                  </a>
                  <ng-template ngbNavContent>
                    <app-studyaccessinfo [studyVM]="newStudy"></app-studyaccessinfo>
                  </ng-template>
                </li>

                <li [ngbNavItem]="4" [disabled]="developmentMode">
                  <a ngbNavLink id="review_submit">
                    <span class="p-steps-number joinline"></span>
                    <span class="p-steps-title">Review & Submit</span>
                  </a>
                  <ng-template ngbNavContent>
                    <div class="display-data">
                      <div class="header">
                        Study Information
                        <a class="float-right" (click)="selectedTab = tabsteps.studyInfo">
                          <i class="material-icons"> edit </i>
                          <span>Edit</span>
                        </a>
                      </div>
                      <div class="content">
                        <app-studyinforeadonly [studyVM]="newStudy"></app-studyinforeadonly>
                      </div>

                      <div class="header">
                        Tested Party Information
                        <a (click)="selectedTab = tabsteps.testedPartyInfo">
                          <i class="material-icons"> edit </i>
                          <span>Edit</span>
                        </a>
                      </div>
                      <div class="content">
                        <app-testedpartyinforeadonly [studyVM]="newStudy"></app-testedpartyinforeadonly>
                      </div>

                      <div class="header">
                        Study Access
                        <a (click)="selectedTab = tabsteps.studyAccess">
                          <i class="material-icons"> edit </i>
                          <span>Edit</span>
                        </a>
                      </div>
                      <div class="content">
                        <app-studyaccessinforeadonly [studyVM]="newStudy"></app-studyaccessinforeadonly>
                      </div>
                    </div>
                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </ng-container>

          <div class="completedStage" *ngIf="formCompleted">
            <div class="row">
              <div class="col-12">
                <i class="material-icons"> check_circle </i>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="success-message">Success!</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="message">
                  The benchmark study has been successfully created, please select from one of the following options to proceed.
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="button" class="btn btn-primary" (click)="redirectToQuantitativeSearch()">Start Search Strategy</button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="button" class="btn btn-default" (click)="redirectToMyStudies()">Go To My Studies</button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="button" class="btn btn-default" (click)="redirectToSearchStudies()">Go To Search Studies</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer" *ngIf="!formCompleted">
      <button
        type="button"
        class="btn btn-default"
        *ngIf="selectedTab === tabsteps.leverageStudy || (selectedTab === tabsteps.studyInfo && !leveragedStudyId)"
        (click)="close()"
      >
        Cancel
      </button>
      <button type="button" class="btn btn-primary" *ngIf="selectedTab === tabsteps.leverageStudy && leveragedStudyId" (click)="confirm()">
        Confirm
      </button>
      <button
        type="button"
        class="btn btn-default"
        *ngIf="selectedTab !== tabsteps.leverageStudy && !(selectedTab === tabsteps.studyInfo && !leveragedStudyId)"
        (click)="backTab()"
      >
        Back
      </button>
      <button
        type="button"
        class="btn btn-primary"
        *ngIf="selectedTab !== tabsteps.leverageStudy && selectedTab !== tabsteps.review_submit"
        (click)="nextTab(studyForm)"
      >
        Next
      </button>
      <button type="submit" class="btn btn-primary" *ngIf="selectedTab === tabsteps.review_submit">Create Study</button>
    </div>
  </div>
</form>
